import makeStyles from "@mui/styles/makeStyles";
import { FeatureListProps } from "./FeaturesList.types";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    listStyle: "none",
    justifyContent: "space-between",
    padding: 0,
  },
  item: {
    display: "flex",
    paddingTop: "12px",
  },
  icon: {
    width: 16,
    height: 16,
    marginRight: 4,
  },
  iconEnabled: {
    color: theme.palette.primary.main,
  },
  iconDisabled: {
    color: theme.palette.grey[600],
  },
  alertLink: {
    fontWeight: "bold",
    textDecoration: "none",
    color: theme.palette.primary.main,
    display: "inline-flex",
    alignItems: "center",
    marginLeft: 4,
    "& svg": {
      color: theme.palette.primary.main,
      fontSize: 18,
    },
  },
}));
